import React from 'react'
import { NotifyWrapper } from './ProvablyFormStyled'
interface Notify_props {
  text: string
  error?: boolean
  fadeOut?: boolean
  fadein?: boolean
}
export default function Notify({ text, error, fadeOut }: Notify_props) {
  return (
    <NotifyWrapper error={error} fadeOut={fadeOut} >
      <p>{text}</p>
    </NotifyWrapper>
  )
}
